import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import Text from '../Text';
import { useThemeProps } from '../system';

function HeadingUppercase(_ref) {
  var children = _ref.children,
      restProps = _objectWithoutPropertiesLoose(_ref, ["children"]);

  var themeProps = useThemeProps('HeadingUppercase', restProps);
  return /*#__PURE__*/React.createElement(Text, _extends({
    as: "span",
    uppercase: true,
    fontSize: 5,
    fontWeight: 700,
    cursor: "default",
    color: "foregroundSecondary",
    shrink: 0,
    margin: 0
  }, themeProps), children);
}

export default HeadingUppercase;